<template>
  <div id="MemberSelect">
    <h4 class="card-title text-left" v-show="showTitle">멤버</h4>
    <div class="row">
      <div class="col-md-12 text-left">
        <el-select :multiple="multiple" class="select-primary selector" size="large" placeholder="멤버선택" :value="value" v-model="selectedMemberIds">
          <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";

export default {
  name: "MemberSelect",
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      artistUnit: null,
      members: {
        options: [],
      },
      selectedMemberIds: [],
    };
  },
  props: {
    unitId: {
      type: Number,
      required: false,
    },
    whitelist: {
      type: Array,
      required: false,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    includeUnitArtist: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: [Number, Array],
  },
  watch: {
    unitId: {
      async handler() {
        await this.getArtistMembers();
      },
      immediate: true,
    },
    selectedMemberIds: {
      async handler(newValue, oldValue) {
        if (!this.artistUnit || !this.includeUnitArtist) {
          this.$emit("change", this.selectedMemberIds);
          return;
        }

        const unitArtistId = this.artistUnit.artistId;
        if (newValue.includes(unitArtistId) && !oldValue.includes(unitArtistId)) {
          this.selectedMemberIds = [unitArtistId];
        } else if (oldValue.includes(unitArtistId) && newValue.length > 1) {
          this.selectedMemberIds = newValue.filter((item) => item !== unitArtistId);
        }
        this.$emit("change", this.selectedMemberIds);
      },
      immediate: true,
    },
  },
  methods: {
    async getArtistMembers() {
      const res = await this.$axios.get(`/artistUnit/${this.unitId}`, null);
      this.artistUnit = res.data.data;

      this.members.options = [];
      if (this.includeUnitArtist) {
        this.members.options.push({ value: this.artistUnit.artistId, label: this.artistUnit.blipName });
      }
      this.members.options = this.members.options.concat(
        this.artistUnit.members
          .map((item) => {
            if (!_.isEmpty(this.whitelist) && !_.includes(this.whitelist, item.artistId)) {
              return null;
            }

            return {
              value: item.artistId,
              label: item.blipName ?? item.name,
            };
          })
          .filter((item) => !!item)
      );
    },
  },
};
</script>
<style>
.selector {
  width: 100%;
}
</style>
